import {getLocale} from 'localization/i18n'
import {useNavigate} from 'react-router-dom'

const useDanceItem = (index, total, dance) => {
    const {locale} = getLocale()
    const navigate = useNavigate()

    const onDanceClick = () => {
        navigate(`/dances/${dance._id}`)
    }

    const isFirst = index === 0
    const isLast = index === total - 1

    const displayName =
        locale === 'he'
            ? dance?.choreographersDisplayHeb
            : dance?.choreographersDisplayEng || dance?.choreographersDisplayHeb

    return {
        displayName,
        isFirst,
        isLast,
        onDanceClick,
    }
}

export default useDanceItem
